export function adminReducer(state, action) {
  switch (action.type) {
    case "loadAdmins":
      return {
        ...state,
        admins: action.admins,
      };
    case "deleteAdmin":
      return {
        ...state,
        admins: state.admins.filter(
          (item) => parseInt(item.id) != parseInt(action.adminId)
        ),
      };
    case "showModal":
      return {
        ...state,
        showModal: true,
        currentUser: action.currentUser,
      };
    case "hideModal":
      return {
        ...state,
        showModal: false,
        currentUser: null,
      };
    default:
      throw new Error();
  }
}
